export default __webpack_public_path__ + "022b286549d7db906dd2489b9058e502.png";